import { NgModule } from '@angular/core';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { BmsjHipsterSharedModule } from '../../shared';
import { RouterModule } from '@angular/router';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FieldMapComponent } from './field-map.component';
import { FIELD_MAP_ROUTES } from './field-map.route';
import { HelpLinkComponent } from '../../shared/help-link/help-link.component';

@NgModule({
    declarations: [
        FieldMapComponent
    ],
    imports: [
        DragDropModule,
        BmsjHipsterSharedModule,
        RouterModule.forChild(FIELD_MAP_ROUTES),
        ScrollingModule,
        HelpLinkComponent
    ]
})
export class FieldMapModule {
}
